import React, { useContext } from 'react';
import { get } from 'lodash-es';
import { VideoConfContext } from 'components/VideoConf/index.js';
import ShowLocationType from './ShowLocationType.jsx';
import { LOCATION_TYPE_VIDEO } from './constants.js';

function useSelectLocationType() {
  const { removeVideo, lockedVideo } = useContext(VideoConfContext);
  function showLocationType(attrs) {
    const { meeting, onChange, defaultMeetingLocationType, ...rest } = attrs;
    const videoInfo = get(meeting, 'videoMeeting.info');
    const title = lockedVideo(videoInfo);
    function handleChange(meetingLocationType) {
      if (videoInfo && meetingLocationType !== LOCATION_TYPE_VIDEO) {
        removeVideo(meeting);
      }
      onChange({ ...meeting, videoMeeting: null, meetingLocationType });
    }
    return (
      <ShowLocationType
        {...rest}
        value={(meeting && meeting.meetingLocationType) || defaultMeetingLocationType}
        onChange={handleChange}
        disabled={Boolean(title)}
        title={title}
        withChoose={!get(meeting, 'details.assigned')}
      />
    );
  }
  return showLocationType;
}

export default useSelectLocationType;
